import { LockOutlined } from "@ant-design/icons";
import { Alert, Button, Flex, Form, Input } from "antd";
import {
  PASSWORD_VALIDATION_REGEX,
  PasswordRequirementsList,
} from "components/passwordRequirementsList";
import { useState } from "react";
import styled from "styled-components";
import useChangePassword from "./useChangePassword";

const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const StyledHeading = styled.h2`
  margin-top: 0;
  text-align: center;
`;

const StyledCard = styled(Flex)`
  flex: 1;
  max-width: 400px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  padding: 48px;
  background: #fff;
  border-radius: 10px;
`;

const StyledContainer = styled(Flex)`
  height: 100%;
  width: 100%;
`;

function ConsumerChangePassword() {
  const [newPassword, setNewPassword] = useState("");
  const { onFinish, errorMessage, isLoading } = useChangePassword();

  return (
    <StyledContainer justify="center" align="center">
      <StyledCard vertical>
        <StyledHeading>Change Password</StyledHeading>
        <StyledForm
          autoComplete="off"
          onFinish={onFinish}
          className="change-password-form"
          initialValues={{
            old: "",
            new: "",
            confirmNew: "",
          }}
        >
          <Form.Item
            name="oldPassword"
            rules={[{ required: true, message: "Please enter old password" }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              autoComplete="new-password"
              placeholder="Enter current password"
            />
          </Form.Item>
          <Form.Item
            hasFeedback
            name="newPassword"
            rules={[
              { required: true, message: "Please enter new password" },
              {
                pattern: PASSWORD_VALIDATION_REGEX,
                message: "Please meet all password requirements",
              },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              type="password"
              placeholder="Enter new password"
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </Form.Item>
          <PasswordRequirementsList password={newPassword} />
          <Form.Item
            hasFeedback
            name="confirmPassword"
            rules={[
              { required: true, message: "Confirm new password" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Passwords don't match"));
                },
              }),
            ]}
            dependencies={["newPassword"]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              type="password"
              placeholder="Confirm new password"
            />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button"
              style={{ width: "100%", height: "50px" }}
              loading={isLoading}
            >
              Change Password
            </Button>
          </Form.Item>
          {errorMessage ? (
            <Form.Item>
              <Alert message={errorMessage} type="error" />
            </Form.Item>
          ) : null}
        </StyledForm>
      </StyledCard>
    </StyledContainer>
  );
}

export default ConsumerChangePassword;
